<template>
    <div class="home" id="cisRsi">

        <div class="rfbSuchfeld">
            {{ suchfeldDetail.LitName }} 
        </div>
        <div>
            <VueTagCloud :options="cloudOptions" @tagClicked="tagClicked($event)"
                         v-bind:data="keyWords"></VueTagCloud>
        </div>
        <div class="cisRssFilters">
            <div class="cisRssFilter">
                <div class="cisRssFilter">
                    <DxButton :text="btn.SelectSFBtn" @click="this.$router.push({ name: 'RssFeedBrowserIntro' })" />
                </div>
                <div class="cisRssFilterLabel">
                    Feed:
                </div>
                <div class="cisRssFilterField">
                    <div class="cisRssFilterFieldGroup">
                        <div>
                            <DxSelectBox displayExpr="RssName" :dataSource="rssFeedList" valueExpr="RssId" v-model="rssId">
                            </DxSelectBox>
                        </div>
                        <div>
                            <DxButton icon="far fa-plus-square feedIcon" class="feedIconBtn" @click="addRssClick(data)" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="cisRssFilter">
                <div class="cisRssFilterLabel">
                    {{tx.LangDrp}}
                </div>
                <div class="cisRssFilterField">
                    <DxSelectBox displayExpr="name" :dataSource="languages" valueExpr="id" v-model="lang" placeholder="Choose Language...">
                    </DxSelectBox>
                </div>
            </div>
            <div class="cisRssFilter">
                <div class="cisRssFilterLabel">
                    {{tx.FilterDrp}}
                </div>
                <div class="cisRssFilterField">
                    <DxTagBox class=".NOCHOSEN" :items="filter" displayExpr="text" v-model:value="filteredValues" valueExpr="id" :searchEnabled="true" :searchExpr="text" placeholder="Choose Filter..." />
                </div>
            </div>
            <div class="cisRssFilter">
                <div class="cisRssFilterField rsSearchBox">
                    <DxAutocomplete v-model:value="searchText" :data-source="autoCompleteData" value-expr="suggestion"
                                    valueChangeEvent="input focusout" showClearButton="true">
                        <DxTextBoxButton name="clear1" location="after" :options="clearButton" v-model:visible="clearButtonVisble" />
                        <DxTextBoxButton :options="searchButton"
                                         name="search"
                                         location="after" />
                    </DxAutocomplete>
                </div>
            </div>
            <div class="cisRssFilter">
                <div class="cisRssFilterLabel">
                    {{tx.Count}}
                </div>
                <div class="cisRssFilterField" v-if="!loadingStatus">
                    {{ entryCount }}
                </div>
            </div>
        </div>
        <div class="rfbIndicator" :key="indicatorKey" v-if="loadingStatus">
            <div class="rfbIndicatorBox">
                <div class="rfbIndicatorBoxSpinner fa fa-spinner fa-spin"></div>
                <div class="rfbIndicatorBoxText">Loading RSS feed entries ...</div>
            </div>
        </div>

        <div class="rfbCardBox" v-if="!loadingStatus && !isLoading">
            <div v-for="data in rssEntryList" :key="data.RfeId" class="rfbEntry">
                <div class="dx-tile-content rsiCard" @mouseenter="loadEntryImportInfo(data)">
                    <div class="rfbHeader" :id="'rsi' + data.RfeId" :ref="'rsi' + data.RfeId">
                        <div class="rfbTitle">
                            <div class="rfeTopLine">
                                <div class="rfbCheckbox">
                                    <DxCheckBox>

                                    </DxCheckBox>
                                </div>
                                <div class="rfbHeaderText">
                                    {{ moment(data.EntryPublishingDate).format('DD.MM.YYYY hh:mm') }} - <a :href="data.EntryFeedLink" target="_blank">{{ data.EntryFeedName }}</a>
                                </div>
                                <div class="rfbEntryScore">
                                    {{    numeralFormat(data.score)  }}
                                </div>
                                <div class="rfbEntryImportInfo" v-if="data.EntryTopicCount > 0">
                                    {{ data.EntryTopicCount }} x importiert
                                </div>
                            </div>
                            <div class="rfeSecondLine">
                                <a :href="data.EntryLink" target="_blank" class="rfbLink">
                                    <div class="rfeTitle">{{ data.EntryTitle }}</div>
                                </a>
                                <div class="rfeButtons">
                                    <DxButton icon="fal fa-trash-alt feedIcon" class="feedIconBtn" @click="deleteClick(data)" />
                                    <!--<DxButton icon="fas fa-trash-can-slash" @click="unDeleteClick(data)" />-->
                                    <DxButton icon="fal fa-plus-circle feedIcon" class="feedIconBtn" @click="importClick(data)" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="rfeImageBox" v-if="data.EntryEnclosureUrl && data.EntryEnclosureUrl.length > 0 ">
                        <a :href="data.EntryEnclosureUrl" target="_blank" class="rfbLink">
                            <div v-if="data.RffId > 0 && !data.RffContentType.startsWith('image')" class="rfeImage">
                                <div class="rfbNoImage">
                                    <div v-if="data.RffContentType.endsWith('pdf')">
                                        <div v-if="data.PreviewUrl > ''" class="rfeImage rsiPreview">
                                            <img v-lazy="data.PreviewUrl" class="" />
                                        </div>
                                        <div v-else>
                                            <i class="fa fa-file-pdf rsiNoImageIcon"></i>
                                        </div>
                                    </div>
                                    <div v-else-if="data.RffContentType.endsWith('zip')">
                                        <i class="fa fa-box-alt rsiNoImageIcon"></i>
                                    </div>
                                    <div v-else-if="data.RffContentType.startsWith('audio/')">
                                        <i class="fa fa-podcast rsiNoImageIcon"></i>
                                    </div>
                                    <div v-else-if="data.RffContentType.startsWith('video/')">
                                        <i class="fa fa-film rsiNoImageIcon"></i>
                                    </div>
                                    <div v-else>
                                        <i class="fa fa-image rsiNoImageIcon"></i>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="rfeImage">
                                <img v-lazy="data.EntryEnclosureUrl" />
                            </div>
                        </a>
                    </div>
                    <div v-else class="rfeImageBox">
                        <div class="rfeImage">
                            <div class="rfbNoImage">
                                <i class="fad fa-image rsiNoImageIcon"></i>
                            </div>
                        </div>
                    </div>
                    <div class="rfeDescription">{{ data.EntryDescription }}</div>
                    <div v-if="data.RfeId == rfeId "><img src @error='gotoStartRfe' /></div>
                </div>
                <DxTooltip :target="'#rsi' + data.RfeId" v-if="data.EntryTopicCount > 0"
                           show-event="dxhoverstart"
                           hide-event="dxclick">

                    <div>
                        <div v-if="data.EntryImportInfos && data.EntryImportInfos.length > 0" class="rfbInfoTable">
                            <div v-for="rec in data.EntryImportInfos" :key="rec.TopicId" class="rfbInfoRow">
                                <div class="rfbTopicId" @click="gotoTopicClick(rec, data)">{{ rec.TopicId }}</div>
                                <div class="rfbTtyName">{{ rec.TtyName }}</div>
                                <div class="rfbCreatedBy">{{ rec.CreatedBy }}</div>
                                <div class="rfbCreatedOn">{{ moment(rec.CreatedOn).format('DD.MM.YYYY hh:mm')  }}</div>
                                <div class="rfbRounds"><span v-if="rec.Rounds != null">{{ rec.Rounds.join(", ") }}</span></div>
                            </div>
                        </div>
                    </div>

                </DxTooltip>
            </div>
        </div>

        <div class="rfbPopups" v-if="!loadingStatus">
            <DxPopup v-model:visible="importPopupVisible"
                     :drag-enabled="false"
                     :close-on-outside-click="true"
                     :show-close-button="false"
                     :show-title="true"
                     :width="auto"
                     :height="auto"
                     title="Import Feed Entry">
                <DxPosition at="center"
                            my="center"
                            v-model:of="window" />
                <DxToolbarItem widget="dxButton"
                               toolbar="bottom"
                               location="before"
                               :options="cancelImportButtonOptions" />
                <DxToolbarItem widget="dxButton"
                               toolbar="bottom"
                               location="after"
                               v-bind:disabled="importDisabled"
                               :options="importButtonOptions" />
                <div class="rfbCreatePopupBox">
                    <div class="rfbTtySelection">
                        <div class="rfbSelectionLabel">Typ</div>
                        <div class="rfbSelectionList">
                            <DxList :data-source="ttyCanCreateList"
                                    v-model:selected-item-keys="selectedTtyIds"
                                    selection-mode="single"
                                    :show-selection-controls="true"
                                    :search-enabled="true"
                                    search-mode="contains"
                                    display-expr="TtyName"
                                    key-expr="TtyId"
                                    search-expr="TtyName">
                                <template #item="{ data }">
                                    <div>
                                        <div>{{ data.TtyName }}</div>
                                    </div>
                                </template>
                            </DxList>
                        </div>
                    </div>
                    <!--<div class="rfbSuchfeldSelection">
                        <div class="rfbSelectionLabel">Suchfelder</div>
                        <div class="rfbSelectionList">
                            <DxList :data-source="suchfeldForRoundList"
                                    v-model:selected-item-keys="selectedLitIds"
                                    selection-mode="multiple"
                                    :show-selection-controls="true"
                                    :search-enabled="true"
                                    search-mode="contains"
                                    display-expr="LitName"
                                    key-expr="LitId"
                                    search-expr="LitName">
                                <template #item="{ data }">
                                    <div>
                                        <div>{{ data.LitName }}</div>
                                    </div>
                                </template>
                            </DxList>
                        </div>
                    </div>-->
                </div> 
            </DxPopup>



            <DxPopup v-model:visible="addRssPopupVisible"
                     :drag-enabled="false"
                     :close-on-outside-click="true"
                     :show-close-button="false"
                     :show-title="true"
                     :width="auto"
                     :height="auto"
                     title="Add new RSS Feed">
                <DxPosition at="center"
                            my="center"
                            v-model:of="window" />
                <DxToolbarItem widget="dxButton"
                               toolbar="bottom"
                               location="before"
                               :options="cancelAddRssOptions" />
                <DxToolbarItem widget="dxButton"
                               toolbar="bottom"
                               location="after"
                               :options="addRssButtonOptions" />
                <div class="rfbAddRssPopupBox">
                    <div class="rfbAddRssForm">
                        <div class="rfbAddRssLabel">URL</div>
                        <div class="rfbAddRssValue"><DxTextBox v-model:value="rssData.RssUrl" /></div>
                        <div class="rfbAddRssLabel">Name</div>
                        <div class="rfbAddRssValue"><DxTextBox v-model:value="rssData.RssName" /></div>
                        <div class="rfbAddRssLabel">Import Scheduled</div>
                        <div class="rfbAddRssValue"><DxCheckBox v-model:value="rssData.RssRunScheduled" /></div>
                    </div>
                </div>
            </DxPopup>
        </div>
    </div>
</template>

<script>
    import { DxSelectBox } from 'devextreme-vue/select-box'
    import { DxCheckBox } from 'devextreme-vue/check-box'
    import { DxButton } from 'devextreme-vue/button'
    import { DxTagBox } from 'devextreme-vue/tag-box'
    import { DxTextBox } from 'devextreme-vue/text-box'
    import { DxAutocomplete } from 'devextreme-vue/autocomplete'
    import { DxPopup, DxPosition, DxToolbarItem } from 'devextreme-vue/popup'
    import { DxTooltip } from 'devextreme-vue/tooltip'
    import { DxList } from 'devextreme-vue/list'
    import { DxButton as DxTextBoxButton } from 'devextreme-vue/text-box'
    import $ from 'jquery';

    import VueTagCloud from "../components/VueTagCloud"
    import moment from 'moment'
    import sortArray from 'sort-array'
    import 'es6-promise/auto'
    export default {
        name: 'RssFeed',
        components: {
            DxTextBox, DxButton, DxTagBox, DxPopup, DxPosition, DxList, DxToolbarItem, DxCheckBox, DxTooltip, DxAutocomplete, DxTextBoxButton,
            VueTagCloud, DxSelectBox
        },
        data() {
            return {
                isLoadingInternal: true,
                indicatorKey: 0,
                useCache: false,
                tx: {
                    LangDrp: this.$LanguageProvider.GetResource("LangDrp", "Caption", "Sprache:"),  
                    Count: this.$LanguageProvider.GetResource("Count", "Caption", "Anzahl:"),
                    FilterDrp: this.$LanguageProvider.GetResource("FilterDrp", "Caption", "Filter:"),
                    FeedDrp: this.$LanguageProvider.GetResource("FeedDrp", "Caption", "Feed:"),
                },
                btn: {
                    SelectSFBtn: this.$LanguageProvider.GetResource("SelectSFBtn", "Caption", "Suchfeldauswahl"),
                },
                keyWordsInternal: [],
                rssEntryListInternal: [],
                rssFeedGridOptions: {
                    columns: [{ dataField: 'RssName', caption: "Alle", sortIndex: 1 }],
                    filterPanel: { visible: false },
                    searchPanel: { visible: false }
                },
                treeViewName: 'tree-view',
                startTime: new Date(),
                cloudOptions: { valueExpr: 'Salience', nameExpr: 'Name', width: 'auto' },
                rssData: {
                    RssName: '',
                    RssUrl: '',
                    RssRunScheduled: true
                },
                filter: [
                    {
                        id: 3, text: "Alle"
                    }, {
                        id: 1, text: "Gelöschte"
                    }, {
                        id: 2, text: "Importierte"
                    }, {
                        id: 5, text: "aktuelle"
                    },
                    {
                        id: 101, text: "letzte 24h"
                    },
                    {
                        id: 102, text: "letzte Woche "
                    },
                    {
                        id: 103, text: "letzter Monat "
                    },
                    {
                        id: 104, text: "letztes Jahr "
                    }],
                searchButton: {
                    icon: 'fal fa-search',
                    type: 'default',
                    onClick: this.setSearchFilter
                },
                clearButton: {
                    icon: 'fal fa-times-circle',
                    type: 'default',
                    onClick: this.resetSearch,
                },
                importPopupVisible: false,
                addRssPopupVisible: false,
                selectedEntry: null,
                selectedTtyIds: [],
                selectedLitIds: [],
                importButtonOptions: {
                    icon: 'fal fa-share-square',
                    text: 'Import',
                    onClick: () => {
                        if (this.selectedTtyIds && this.selectedTtyIds.length > 0) {
                            const ttyId = this.selectedTtyIds[0]
                            if (ttyId > 0) {
                                $("form").attr("action", window.location.pathname + "?action=create&rfeId=" + this.selectedEntry.RfeId + "&cmd=importRfe&ttyId=" + ttyId + "&topicId: 0&rouId=" + this.rouId).submit()
                                //this.$router.push({ name: "TopicEntry", params: { rfeId: this.selectedEntry.RfeId, cmd: 'importRfe', ttyId: ttyId, topicId: 0, rouId: this.rouId } })/*, selectedLitIds: this.selectedLitIds } })*/
                            }
                        }
                    }
                },
                addRssButtonOptions: {
                    icon: 'fal fa-share-square',
                    text: 'Add',
                    //disabled: this.addRssDisabled,
                    onClick: () => {
                        this.$store.dispatch("addRssFeed", this.rssData)
                        this.addRssPopupVisible = false
                    }
                },
                cancelImportButtonOptions: {
                    icon: 'fal fa-ban',
                    text: 'Cancel',
                    onClick: () => {
                        this.importPopupVisible = false
                    }
                },
                cancelAddRssOptions: {
                    icon: 'fal fa-ban',
                    text: 'Cancel',
                    onClick: () => {
                        this.addRssPopupVisible = false
                    }
                }
            }
        },
        props: {
            litId: {
                type: [Number],
                required: true,
                default: 0
            },
            rouId: {
                type: [Number],
                required: true,
                default: 0
            },
        },
        watch: {
            rssId: function (newVal, oldVal) {
                if (oldVal && newVal != oldVal && oldVal >= 0) {
                    this.isLoading = true
                    this.saveFilter()
                    this.$store.dispatch("getRssEntryList", { rssId: this.rssId, litId: this.litId, lang: this.lang })
                }
            },
            lang: function (newVal, oldVal) {
                if (newVal != oldVal && oldVal >= '') {
                    this.isLoading = true
                    this.saveFilter()
                    this.$store.dispatch("getRssEntryList", { rssId: this.rssId, litId: this.litId, lang: this.lang })
                }
            },
        },
        computed: {
            rssEntryList() {
                var start = new Date()
                console.log("rssEntryList START for '" + this.searchFilter + "'", moment(new Date()).diff(this.startTime) + 'ms')
                if (this.useCache) {
                    let filter = JSON.stringify(this.currentFilter)
                    if (filter == localStorage.rssEntryListTrigger) {
                        console.log("rssEntryList FINISHED CACHE", moment(new Date()).diff(this.startTime) + 'ms', moment(new Date()).diff(start) + 'ms*')
                        return localStorage.rssEntryList
                    }
                    localStorage.rssEntryListTrigger = filter
                }
                this.scoreList()
                let list = this.$store.state.rssFeedStore.rssFeedEntryList
                var result = list
                if (list && list.length >= 0) {
                    result = list.filter(data => { return this.show(data) && (moment(data.EntryPublishingDate).toDate() > this.timeBorder) })
                    sortArray(result, {
                        by: ['score', 'EntryPublishingDate'],
                        order: ['desc', 'desc']
                    })
                    window.isListLoading = false
                    if (this.useCache) {
                        localStorage.rssEntryList = result
                    }
                }
                console.log("rssEntryList FINISHED COMPUTED", moment(new Date()).diff(this.startTime) + 'ms', moment(new Date()).diff(start) + 'ms*')
                return result
            },
            suchfeldDetail() {
                return this.$store.state.suchfeldStore.suchfeldDetail
            },
            keyWords() {
                var start = new Date()
                //if (!window.a) return []
                console.log("keyWords START", moment(new Date()).diff(this.startTime) + 'ms')
                if (this.useCache) {
                    let filter = JSON.stringify(this.currentFilter)
                    if (filter == localStorage.lastKwFilter) {
                        console.log("keyWords FINISHED CACHE", moment(new Date()).diff(this.startTime) + 'ms', moment(new Date()).diff(start) + 'ms*')
                        return localStorage.keyWordsInternal
                    }
                    localStorage.lastKwFilter = filter
                }
                let list = this.rssEntryList ? this.rssEntryList : []
                var result = []
                list.forEach(e => {
                    let kw = e.EntryKeyWords ? e.EntryKeyWords : []
                    kw = kw.filter(w => w.Salience > .1)
                    kw.forEach(w => {
                        let entry = result.find(e => e.Name.toLowerCase().trim() == w.Name.toLowerCase().trim())
                        if (entry) {
                            entry.Name = entry.Name.trim()
                            entry.Salience = entry.Salience + w.Salience
                        }
                        else {
                            result.push(w)
                        }
                    })
                });
                sortArray(result, {
                    by: ['Salience', 'Name'],
                    order: ['desc', 'asc']
                })
                result = result.slice(0, 20)
                if (this.useCache) {
                    localStorage.keyWordsInternal = result
                }
                console.log("keyWords FINISHED COMPUTED", moment(new Date()).diff(this.startTime) + 'ms', result.length, moment(new Date()).diff(start) + 'ms*')
                return result
            },
            rssFeedList() {
                return this.$store.state.rssFeedStore.rssFeedList
            },
            languages() {
                return this.$store.state.rssFeedStore.languages
            },
            ttyCanCreateList() {
                return this.$store.state.topicTypeStore.ttyCanCreateList
            },
            openRoundList() {
                return this.$store.state.roundStore.openRoundList
            },
            suchfeldForRoundList() {
                return this.$store.state.roundStore.suchfeldForRoundList
            },
            roundSuchfeldList() {
                return this.$store.state.roundStore.roundSuchfeldList
            },
            loadingStatus() {
                var result = this.$store.state.rssFeedStore.rssFeedEntryListIsLoading
                    || this.$store.state.rssFeedStore.rssFeedListIsLoading
                    || this.$store.state.topicTypeStore.ttyCanCreateListIsLoading
                    || this.isLoading
                return result
            },
            importDisabled() {
                return !this.selectedTtyIds || this.selectedTtyIds.length == 0  //|| !this.selectedLitIds || this.selectedLitIds.length == 0
            },
            addRssDisabled() {
                return !(this.rssData.RssName && this.rssData.RssName.length > 0 &&
                    this.rssData.RssUrl && this.rssData.RssUrl.length > 0)
            },
            clearButtonVisible() {
                return this.searchText && this.searchText.length > 0
            },
            timeBorder() {
                if (this.filteredValues.filter(m => m == 101).length > 0) {
                    return moment(new Date()).add(-24, 'h').toDate()
                }
                else if (this.filteredValues.filter(m => m == 102).length > 0) {
                    return moment(new Date()).add(-7, 'd').toDate()
                }
                else if (this.filteredValues.filter(m => m == 103).length > 0) {
                    return moment(new Date()).add(-1, 'M').toDate()
                }
                else if (this.filteredValues.filter(m => m == 104).length > 0) {
                    return moment(new Date()).add(-1, 'y').toDate()
                }
                return moment(0).toDate()
            },
            filteredValues: {
                get() {
                    return this.$store.state.rssFeedStore.filteredValues
                },
                set(value) {
                    if (!this.loadingStatus && this.$store.state.rssFeedStore.filteredValues != value) {
                        this.$store.state.rssFeedStore.filteredValues = value
                        this.saveFilter()
                    }
                }
            },
            searchFilter: {
                get() {
                    return this.$store.state.rssFeedStore.searchFilter
                },
                set(value) {
                    value = value ? value : ""
                    if ((this.$store.state.rssFeedStore.searchFilter != value)) {
                        this.isLoading = true
                        //this.showLoading()

                        this.$store.state.rssFeedStore.searchFilter = value
                        this.saveFilter()
                    }
                }
            },

            isLoading: {
                get() {
                    return this.isLoadingInternal
                },
                set(value) {
                    if (value) {
                        this.indicatorKey += 1
                    }
                    this.isLoadingInternal = value
                }
            },
            searchText: {
                get() {
                    return this.$store.state.rssFeedStore.searchText
                },
                set(value) {
                    value = value ? value : ""
                    this.$store.state.rssFeedStore.searchText = value
                }
            },
            rssId: {
                get() {
                    return this.$store.state.rssFeedStore.rssId
                },
                set(value) {
                    this.$store.commit('SET_RSSID', value)
                }
            },
            lang: {
                get() {
                    return this.$store.state.rssFeedStore.lang
                },
                set(value) {
                    return this.$store.state.rssFeedStore.lang = value
                }
            },
            rfeId: {
                get() {
                    return this.$store.state.rssFeedStore.rfeId
                },
                set(value) {
                    if (this.$store.state.rssFeedStore.rfeId != value) {
                        this.$store.commit('SET_RFEID', value)
                        if (!this.loadingStatus) {
                            this.saveFilter()
                        }
                    }
                }
            },
            entryCount() {
                if (!this.loadingStatus && this.rssEntryList != null) {
                    return this.rssEntryList.length
                }
                else {
                    return 0
                }
            },
            autoCompleteData() {
                return this.$store.state.rssFeedStore.miniSearch.autoSuggest(this.searchText ? this.searchText : "",
                    {
                        fields: ['title', 'description'],
                        searchOptions: {
                            boost: { title: 2, description: 1 },
                            fuzzy: 0.2,
                            prefix: true
                        }
                    })
            },
            currentFilter() {
                return { rssId: this.rssId, rfeId: this.rfeId, filteredValues: this.filteredValues, searchFilter: this.searchFilter, litId: this.litId, lang: this.lang }
            }
        },
        mounted() {
            this.$store.dispatch("getRssFeedList")
            this.$store.dispatch("getRssEntryList", { rssId: - 1, litId: this.litId })
            this.$store.dispatch("getTtyCanCreateList")
            //this.$store.dispatch("getOpenRoundList")
            //this.$store.dispatch("getSuchfeldForRoundList", { rouId: this.rouId })
            this.$store.dispatch("getSuchfeldDetail", { litId: this.litId })
        },
        updated: function () {
            console.log("UPDATED", moment(new Date()).diff(this.startTime) + 'ms')
            this.isLoading = false

        },
        created: function () {
            this.moment = moment
        },
        methods: {
            tagClicked(args) {
                this.searchText = args.word.Name
                this.setSearchFilter()
            },
            gotoStartRfe() {
                this.$nextTick(() => {
                    if (this.rfeId && this.rfeId > 0) {
                        this.goto("rfb" + this.rfeId)
                    }
                })
            },
            goto(refName) {
                var element = this.$refs[refName];
                if (element) {
                    var top = element.offsetTop;
                    window.scrollTo(0, top);
                }
            },
            saveFilter() {
                return this.$store.dispatch("saveFilter", this.currentFilter);
            },
            deleteClick(data) {
                this.$store.dispatch("hideEntry", data)
            },
            unDeleteClick(data) {
                this.$store.dispatch("hideEntry", data)
            },
            importClick(data) {
                this.selectedEntry = data
                this.importPopupVisible = true
                this.rfeId = data.RfeId
            },
            addRssClick() {
                this.addRssPopupVisible = true
            },
            gotoTopicClick(rec, data) {
                this.rfeId = data.RfeId
                this.saveFilter()
                    .then(() =>
                        window.location.href = window.location.pathname + "?action=view&id=" + rec.TopicId
                    )
            },
            show(data) {
                var vm = this
                var result = ((!vm.importDisabled) ||
                    (vm.filteredValues.filter(m => m == 3).length > 0) ||
                    (vm.filteredValues.filter(m => m < 100).length == 0 && !data.EntryHidden && !data.EntryImported) ||
                    (vm.filteredValues.filter(m => m == 1).length > 0 && data.EntryHidden) ||
                    (vm.filteredValues.filter(m => m == 2).length > 0 && data.EntryTopicCount > 0) ||
                    (vm.filteredValues.filter(m => m == 5).length > 0 && data.EntryTopicCount == 0 && !data.EntryHidden))
                    && (
                        (vm.searchFilter == null || vm.searchFilter == "")
                        || (data.score > 0))
                return result;
            },
            loadEntryImportInfo(data) {
                if (data.EntryTopicCount > 0 && data.EntryImportInfos.length == 0) {
                    this.$store.dispatch("loadEntryImportInfo", data)
                }
            },
            resetSearch() {
                this.searchText = ""
                this.setSearchFilter()
            },
            scoreList() {
                const store = this.$store
                const ms = store.state.rssFeedStore.miniSearch
                this.searchFilter = this.searchFilter ? this.searchFilter : ""
                let withAnd = this.searchFilter.indexOf('+') > 0;
                let filterExpr = this.searchFilter.replace('+', ' ')
                let options = { combineWith: withAnd ? "AND" : "OR" }
                let results = ms.search(filterExpr, options)
                store.state.rssFeedStore.rssFeedEntryList.forEach(d => {
                    const se = results.find(m => m.id == d.RfeId)
                    if (se && se != null) {
                        d.score = se.score
                    }
                    else {
                        d.score = 0
                    }
                })
            },
            setSearchFilter() {
                var start = new Date()
                this.resetStartTime()
                console.log("setSearchFilter START", moment(new Date()).diff(this.starTime) + 'ms', moment(new Date()).diff(this.startTime) + 'ms')
                this.isLoading = true
                //this.$nextTick(() => {
                //    this.$forceUpdate()
                //}
                //).then(() => {

                this.rfeId = null
                this.searchFilter = this.searchText
                console.log("setSearchFilter FINISHED", moment(new Date()).diff(start) + 'ms')

                // })
            },

            hideLoading() {
                eval("LoadingPanel.Hide()")
            },
            showLoading() {
                eval("LoadingPanel.Show()")
            },
            resetStartTime() {
                this.startTime = new Date()
                var store = this.$store
                store.state.startTime = this.startTime
            }
        },
    }

</script>
<style> 

    .rfbSuchfeld {
        padding-left: 15px;
        font-size: 20px;
        font-weight: bold;
    }

    .cisRssFilters {
        display: flex;
        gap: 30px;
        padding: 0 18px 27px;
    }

    .cisRssFilter {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .rfeButtons {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        gap: 3px;
    }

    .rfbCardBox {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        column-gap: 30px;
        row-gap: 30px;
    }

    .rfbEntry {
        display: contents;
    }

    .rfbHeader {
        display: flex;
        flex-direction: row;
        gap: 10px;
        justify-content: space-between;
        width: 100%;
    }

    .rfbTitle {
        width: 100%;
    }

    .rfbCard {
        max-width: 365px;
        height: auto;
        border: solid 1px #d8d4d4;
        padding: 15px;
        display: flex;
        flex-direction: column;
        align-content: space-between;
        align-items: center;
    }

    .rfeImage {
        height: 210px;
        width: 100%;
        justify-content: space-around;
        align-items: center;
        text-align: center;
        background: #e4e4e4;
        border: 0;
        margin: 0;
        box-sizing: border-box;
    }

        .rfeImage img {
            width: 100%;
            display: block;
            height: 100%;
            object-fit: cover;
            margin: auto;
        }

    .rfbNoImage {
        display: grid;
        justify-items: center;
        align-items: center;
        height: inherit;
    }

    .rfbNoImageIcon {
        font-size: 168px;
        color: #b5b5b5;
    }

    .rfeTitle {
        font-size: 15px;
        font-weight: bold;
        word-break: break-word;
        break-inside: auto;
        min-height: 50px;
    }

    div#cisRsi {
        margin-top: 20px;
        display: inline-block; 
    }

    .rfbLink {
        text-decoration: none;
    }

    .cisRssFilterField {
        min-width: 150px;
    }

    .dx-tag {
        padding: 2px;
    }

    .rfeButtons .feedIconBtn, .rfeButtons .feedIconBtn:hover {
        background-color: transparent;
    }


    i.dx-icon.fal.feedIcon {
        color: var(--main-color-1);
        padding: 0px 0px 0px 0px;
        margin-left: -8px;
        margin-bottom: 5px;
    }

        i.dx-icon.fal.feedIcon:hover {
            color: var(--main-color-2);
        }

    .rfbCreatePopupBox {
        display: grid;
        grid-template-columns: 200px 200px;
        gap: 20px;
        padding: 0 10px 10px 0;
    }

    .rfbSelectionLabel {
        font-weight: bold;
        padding-bottom: 10px;
    }

    .rfbSelectionList {
        max-height: 300px;
    }

    .rfeTopLine {
        display: flex;
        flex-direction: row;
    }

    .rfeSecondLine {
        font-size: 10px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .rfbEntryImportInfo {
        justify-self: end;
        margin-left: auto;
    }

    .rfeSecondLine a {
        text-decoration: none;
    }

    .rfbInfoTable {
        display: grid;
        grid-template-columns: 31px auto auto auto auto;
        width: auto;
        gap: 12px;
    }

    .rfbInfoRow {
        display: contents;
    }

    .rfbTopicId {
        text-decoration: underline;
        cursor: pointer;
    }

    .rsSearchBox {
        display: flex;
    }

    .rfbSearchButton {
        margin-left: -30px;
        display: flex;
        align-self: center;
        gap: 5px;
        align-items: center;
        z-index: 10;
    }

    .rfbSearchButtonSearch {
        cursor: pointer;
    }

    .rfbSearchButtonReset {
        cursor: pointer;
    }

    .rfbAddRssPopupBox {
        width: 500px;
    }

    .cisRssFilterFieldGroup {
        display: flex;
        align-items: center;
        gap: 2px;
    }

    .rfbIndicator {
        height: 100%;
        width: 100%;
        position: fixed;
        z-index: 999999999;
        background: #c0c0c099;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .rfbIndicatorBox {
        background: white;
        padding: 33px;
        border-radius: 5px;
        display: flex;
        gap: 11px;
        align-items: center;
        justify-items: center;
    }

    .rfbIndicatorBoxSpinner {
        font-size: 15px;
    }

    .vue-tag-cloud {
        min-height: 30px;
    }

    .rfbContents {
        display: contents;
    }

    .rfeDescription {
        display: inline-block;
        width: 100%;
    }

    .rfeImageBox {
        width: inherit;
        height: inherit;
    }

    .rfeImage.rfbPreview {
        height: 196px;
    }
</style>
